// src/lib/supabase.js
import { createClient } from '@supabase/supabase-js'

// CRA는 REACT_APP_*, Vercel 등에서는 NEXT_PUBLIC_* 도 사용 가능
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || process.env.NEXT_PUBLIC_SUPABASE_URL || ''
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || ''

// 환경 변수 없으면 클라이언트 생성 안 함 (콘솔 출력 없음, 앱은 로드됨)
let supabaseClient = null;

if (supabaseUrl && supabaseAnonKey) {
  try {
    supabaseClient = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true
      }
    });
  } catch (_err) {
    supabaseClient = null;
  }
}

export const supabase = supabaseClient;
